var isObject = function isObject(targe) {
  return Object.prototype.toString.call(targe) === '[object Object]';
};

var isNumber = function isNumber(targe) {
  return Object.prototype.toString.call(targe) === '[object Number]';
};

var isString = function isString(targe) {
  return Object.prototype.toString.call(targe) === '[object String]';
};

var isUndefined = function isUndefined(targe) {
  return Object.prototype.toString.call(targe) === '[object Undefined]';
};

var isBoolean = function isBoolean(targe) {
  return Object.prototype.toString.call(targe) === '[object Boolean]';
};

var isArray = function isArray(targe) {
  return Object.prototype.toString.call(targe) === '[object Array]';
};

var isFunction = function isFunction(targe) {
  return Object.prototype.toString.call(targe) === '[object Function]';
};

module.exports = {
  isObject: isObject,
  isNumber: isNumber,
  isString: isString,
  isUndefined: isUndefined,
  isBoolean: isBoolean,
  isArray: isArray,
  isFunction: isFunction
};